/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMandateSignatureCommand
 */
export interface CreateMandateSignatureCommand {
    /**
     * ID of the mandate
     * @type {string}
     * @memberof CreateMandateSignatureCommand
     */
    mandateId: string;
    /**
     * Email address to send the signature request
     * @type {string}
     * @memberof CreateMandateSignatureCommand
     */
    toAddress: string;
    /**
     * Natural person who signs the mandate (optional) — defaults to the debtor when they are a natural person, otherwise to the manager of the legal entity.
     * @type {string}
     * @memberof CreateMandateSignatureCommand
     */
    signatoryId?: string | null;
    /**
     * Mobile of the signatory, checked by the broker in the sending panel — it receives the signature code. Saved on the signatory's record when it changes.
     * @type {string}
     * @memberof CreateMandateSignatureCommand
     */
    signatoryPhone?: string | null;
}

/**
 * Check if a given object implements the CreateMandateSignatureCommand interface.
 */
export function instanceOfCreateMandateSignatureCommand(value: object): value is CreateMandateSignatureCommand {
    if (!('mandateId' in value) || value['mandateId'] === undefined) return false;
    if (!('toAddress' in value) || value['toAddress'] === undefined) return false;
    return true;
}

export function CreateMandateSignatureCommandFromJSON(json: any): CreateMandateSignatureCommand {
    return CreateMandateSignatureCommandFromJSONTyped(json, false);
}

export function CreateMandateSignatureCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMandateSignatureCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'mandateId': json['mandateId'],
        'toAddress': json['toAddress'],
        'signatoryId': json['signatoryId'] == null ? undefined : json['signatoryId'],
        'signatoryPhone': json['signatoryPhone'] == null ? undefined : json['signatoryPhone'],
    };
}

export function CreateMandateSignatureCommandToJSON(json: any): CreateMandateSignatureCommand {
    return CreateMandateSignatureCommandToJSONTyped(json, false);
}

export function CreateMandateSignatureCommandToJSONTyped(value?: CreateMandateSignatureCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mandateId': value['mandateId'],
        'toAddress': value['toAddress'],
        'signatoryId': value['signatoryId'],
        'signatoryPhone': value['signatoryPhone'],
    };
}

